import { render } from "./StockChanges.vue?vue&type=template&id=21d172c2&scoped=true"
import script from "./StockChanges.vue?vue&type=script&lang=js"
export * from "./StockChanges.vue?vue&type=script&lang=js"

import "./StockChanges.vue?vue&type=style&index=0&id=21d172c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d172c2"]])

export default __exports__